import { render, staticRenderFns } from "./sales-unit-price-copy.vue?vue&type=template&id=7c6fb06a&scoped=true&"
import script from "./sales-unit-price-copy.vue?vue&type=script&lang=js&"
export * from "./sales-unit-price-copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6fb06a",
  null
  
)

export default component.exports